import React, { useEffect, useRef, useState } from "react";
import Arrow from "../../assets/SettingsPage/SVG/Arrow 1.svg";
import Plus from "../../assets/SettingsPage/SVG/plus.svg";
import Search from "../../assets/general/searchWhite.svg";
import GuestStatusPost from "../Components/GuestStatusPost";
import { useSearchParams } from "react-router-dom";
import { get_event } from "../../Api/data";
import { getRelevantUsersData } from "../../Api/firebaseAPis";
import ListItem from "@mui/material/ListItem";
import { FixedSizeList } from "react-window";
import { Power3, gsap } from "gsap";
import CrossIcon from "../../assets/notifications/cross.svg";
import GifLoader from "../Components/GifLoader";

function GuestStatus() {
  let [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  const paramIDS = searchParams.get("u");
  const [uid, id] = paramIDS.split("--i=");
  const [invites, setInvites] = useState();
  const [relevantUsers, setRelevantUsers] = useState({});
  const [eventData, setEventData] = useState({});
  const [guestListPlay, setGuestListPLay] = useState();
  const [popupRef2, setPopupRef2] = useState(useRef(null));
  const [loader ,setLoader]=useState(false)

  const swipeUpAnimation = (refData) => {
    gsap.to(refData, 0.8, {
      top: "30%",
      ease: Power3.easeIn,
      display: "flex",
    });
  };

  const swipeDownAnimation = (refData) => {
    gsap.to(refData, 0.8, {
      top: "100%",
      ease: Power3.easeIn,
      display: "none",
    });
  };

  const getEventData = async () => {
    getEventData(true)
    const post = await get_event(uid, id);

    if (Object.keys(post).includes("playlistURL")) {
      let gKeys = [];
      for (var i in post.playlistURL) {
        gKeys.push(Object.keys(post.playlistURL[i])[0]);
      }
      setGuestListPLay(gKeys);
    }
    setEventData(post);

    const invitesData = post.invites;

    setInvites(invitesData);
    const relevantData = await getRelevantUsersData(Object.keys(invitesData));

    const sortedData = relevantData.sort((a, b) => {
      const genderA = a.gender.toLowerCase();
      const genderB = b.gender.toLowerCase();

      if (genderA === "female" && genderB === "male") {
        return -1;
      } else if (genderA === "male" && genderB === "female") {
        return 1;
      } else {
        return 0;
      }
    });
    let lst = sortedData.length - 1;
    for (let i = 0; i < sortedData.length; i++) {
      if (i === 3 || i === 4) {
        let temp = sortedData[i];
        sortedData[i] = sortedData[lst];
        sortedData[lst] = temp;
        lst--;
      }
    }

    setRelevantUsers(sortedData.splice(0, 5));
    getEventData(false)
  };

  function renderRow(props) {
    const { index, style } = props;

    if (eventData.playlistURL) {
      return (
        <ListItem style={style}>
          <GuestStatusPost
            data={props.data ? relevantUsers[props.data[index]] : ""}
            playlistFlag={guestListPlay.includes(
              relevantUsers[props.data[index]].uid
            )}
            invitationStatus={invites[relevantUsers[props.data[index]].uid]}
            id={props.data ? props.data[index] : ""}
          />
        </ListItem>
      );
    } else {
      return (
        <ListItem style={style}>
          <GuestStatusPost
            data={props.data ? relevantUsers[props.data[index]] : ""}
            playlistFlag={false}
            invitationStatus={invites[relevantUsers[props.data[index]].uid]}
            id={props.data ? props.data[index] : ""}
          />
        </ListItem>
      );
    }
  }

  useEffect(() => {
    getEventData();
  }, []);

  return (
    <>
      {loader?<GifLoader/>:
      <section className="col" style={{ gap: 10, height: "120vh"}}>
      <Popup
        popupRef={popupRef2}
        setPopupRef={setPopupRef2}
        swipeDownAnimation={swipeDownAnimation}
        heading={"Wanna add more of your friends?"}
        text={
          "Download the Surge Party app to and invite your friends to the party!"
        }
      />
      <div
        className="row"
        style={{
          justifyContent: "space-between",
          padding: 10,
          alignItems: "center",
        }}
      >
        <div style={{ width: 40 }} onClick={() => window.history.go(-1)}>
          <img src={Arrow} />
        </div>
        <div>
          <h2 style={{ textAlign: "center" }}>Guests</h2>
        </div>
        <div
          onClick={() => {
            swipeUpAnimation(popupRef2);
          }}
        >
          <img
            className="img_event"
            style={{ width: 35, height: 35, padding: 10 }}
            src={Plus}
          />
        </div>
      </div>
      <div className="col" style={{ alignItems: "center" }}>
        <div
          className="row search-bar-container"
          style={{
            alignItems: "center",
            padding: 5,
            paddingLeft: 10,
          }}
        >
          <img
            src={Search}
            style={{
              width: 20,
              height: 20,
            }}
          />
          <input
            className="search-bar"
            placeholder="Search name"
            value={search}
          // onChange={(e) => searchFilter(e.target.value)}
          />
        </div>
      </div>
      <div className="row" style={{ marginTop: 10, justifyContent: "center" }}>
        <div style={{ width: "20vw" }}>
          <p>Profile</p>
        </div>
        <div style={{ width: "25vw" }}>
          <p>Username</p>
        </div>
        <div style={{ width: "20vw" }}>
          <p>Invitation</p>
        </div>
        <div style={{ width: "20vw" }}>
          <p>Playlist</p>
        </div>
      </div>
      <FixedSizeList
        height={500}
        width={"100%"}
        itemSize={100}
        style={{height: Object.keys(relevantUsers).length > 0 ? '65vh': 0}}
        itemCount={Object.keys(relevantUsers).length}
        overscanCount={5}
        itemData={Object.keys(relevantUsers)}
      >
        {renderRow}
      </FixedSizeList>
      <div className="my-3">
        <h1 className="font-semibold text-xl p-1 justify-center">
          To see all the guests, please download our app.
        </h1>
        <div className="popup-container">
          <a
            className="button-download-container"
            href="https://apps.apple.com/us/app/surge-party/id1643038656"
          >
            <button className="bg-[white] flex items-center justify-center mx-auto p-3 rounded-3xl transform active:scale-75 transition-transform cursor-pointer">
              <img
                className="img_event"
                style={{ width: 25, height: 15 }}
                src={window.location.origin + "/downloadIcon.svg"}
              />
              <span className="btn-wtext">Download Surge Party</span>
            </button>
          </a>
        </div>
      </div>
      {/* <GuestStatusPost/> */}
    </section>}
    </>
    
  );
}

const Popup = (props) => {
  return (
    <div className="popup" ref={(el) => props.setPopupRef(el)}>
      <div
        style={{
          textAlign: "right",
          marginRight: 20,
          marginBottom: 10,
        }}
        onClick={() => {
          props.swipeDownAnimation(props.popupRef);
        }}
      >
        <img src={CrossIcon} />
      </div>
      <div>
        <h3>{props.heading}</h3>
      </div>
      <div className="popup-container">
        <p>{props.text}</p>
      </div>
      <div className="popup-container">
        <a
          className="button-download-container"
          href="https://apps.apple.com/us/app/surge-party/id1643038656"
        >
          <div className="button-white">
            <img
              className="img_event"
              style={{ width: 25, height: 15 }}
              src={window.location.origin + "/downloadIcon.svg"}
            />
            <a className="btn-wtext">Download Surge Party</a>
          </div>
        </a>
      </div>
    </div>
  );
};

export default GuestStatus;
